<template>
	<label class="hint-wrapper">{{ getLabel }}
		<img
			v-if="hint"
			:src="require(`@/common/assets/icons/help-${$route.path.startsWith('/gop/') ? 'black' : 'white'}-text.svg`)"
			:title="hint"
			alt="hint"
		/>
		<span v-if="hint && displayHint">{{ hint }}</span>
	</label>
</template>

<script>
export default {
	name: "Hint",
	props: {
		hint: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: false
		},
	},
	computed: {
		getLabel() {
			return this.label ? this.label : ''
		}
	},
	data() {
		return {
			displayHint: false
		}
	}
}
</script>

<style lang="scss" scoped>
.hint {
	.hint-wrapper > span {
		margin-left: 15px;
	}
}
</style>
